/* globals window, OptimizeSuite, BOOMR */
/*eslint-disable no-console*/

'use strict';

const underscore = require('underscore');

/*
 requiring this polyfill because phantomjs 1.9.8 does not have the bind function,
  which is needed by webpack
 This should be removed when our CI is on phantomjs 2 and all our browsers have this function
*/
require('./async_scripts/bind')();

window.asyncInitializer = (modulePromises, timeOut, callback) => {
  const safeInit = (obj, cb) => {
    try {
      obj.init(window.payload, cb);
    } catch (error) {
      OptimizeSuite.TrackingHub.add('DealPage-AsyncFrontEndInit-Error', {
        error,
      });
      if (window.location.hostname === 'localhost') {
        console.error(error);
      }
      cb();
    }
  };

  let loadedModules = 0;
  let initModules = 0;
  const initStart = new Date();
  modulePromises.forEach(modulePromise => {
    modulePromise
      .then(module => {
        loadedModules += 1;
        safeInit(module, () => {
          initModules += 1;
          if (
            initModules === modulePromises.length &&
            typeof BOOMR !== 'undefined' &&
            typeof BOOMR.addVar === 'function'
          ) {
            BOOMR.addVar(
              'deal_page_async_modules_initialized',
              new Date() - initStart
            );
          }
        });
        if (loadedModules === modulePromises.length) {
          window._ = underscore;
          callback(initStart);
        }
      })
      .catch(error => {
        OptimizeSuite.TrackingHub.add(
          'DealPage-AsyncFrontModulePromise-Error',
          { error }
        );
      });
  });

  setTimeout(() => {
    if (loadedModules !== modulePromises.length) {
      OptimizeSuite.TrackingHub.add('DealPage-AsyncFrontModules-Timeout', {
        numberInFlight: loadedModules,
      });
      if (window.location.hostname === 'localhost') {
        console.error('Frontend Async Module Initialization timed out');
      }
      callback(initStart);
    }
  }, timeOut);
};



// WEBPACK FOOTER //
// ./core/frontend/webpack/async_initializer.js